import { Button } from '@octopus-do/octopus-storybook'
import { Clone } from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { GlobalActions } from '@/store'
import { GtmTriggerName, sendGtmEvent } from '../../../../../../constants/gtm'
import css from './Embed.module.scss'

const Embed: React.FC = () => {
  const dispatch = useDispatch()

  const inputRef = useRef<HTMLTextAreaElement>(null)

  const id = useSelector(migrationProjectSelector.getProjectId)

  const iframeCode = `<iframe title="Octopus.do visual sitemap" width="800" height="450" src="${import.meta.env.VITE_EMBED_URL}/${id}"></iframe>`

  const onCopy = async () => {
    if (!inputRef?.current) {
      return
    }

    inputRef.current.select()
    sendGtmEvent(
      GtmTriggerName.EMBED_COPY,
      'Clicked on copy button in Embed tab on Share modal.'
    )
    dispatch(GlobalActions.copy({ value: inputRef.current.value }))
  }

  return (
    <div className={css.container}>
      <textarea ref={inputRef} value={iframeCode} className={css.code} />

      <Button label="Copy" left={Clone} onClick={onCopy} />

      <div className={css.description}>
        Embed sitemap with read-only access.
      </div>
    </div>
  )
}

export default Embed
